export default "__VITE_ASSET__CtpE2HeY__"